// extracted by mini-css-extract-plugin
module.exports = {"container":"i_KA","label":"i_KB"};